import type { ReactNode } from "react";
import {
    FiAlignLeft,
    FiCreditCard,
    FiDollarSign,
    FiFileText,
    FiGrid,
    FiLogOut,
    FiPackage,
    FiRefreshCcw,
    FiShoppingBag,
    FiSliders,
    FiUser,
    FiUsers,
    FiZap,
} from "react-icons/fi";

const iconClass = "w-[19px] h-[19px]";

export function getSmileSidebarIcon(fieldName: string): ReactNode {
    switch (fieldName) {
        case "Smile Generation":
            return <FiZap className={iconClass} />;
        case "Prompts & Filters":
        case "Prompt Manager":
            return <FiAlignLeft className={iconClass} />;
        case "All Smiles":
            return <FiGrid className={iconClass} />;
        case "My Smiles":
        case "Profile":
            return <FiUser className={iconClass} />;
        case "Client Management":
            return <FiUsers className={iconClass} />;
        case "Credit Packages":
            return <FiCreditCard className={iconClass} />;
        case "Payment Manager":
            return <FiDollarSign className={iconClass} />;
        case "Package Manager":
            return <FiPackage className={iconClass} />;
        case "Refund Manager":
            return <FiRefreshCcw className={iconClass} />;
        case "Manual Credits":
            return <FiSliders className={iconClass} />;
        case "Credit Audit Logs":
            return <FiFileText className={iconClass} />;
        case "My Orders":
            return <FiShoppingBag className={iconClass} />;
        default:
            return <FiGrid className={iconClass} />;
    }
}

export const SmileLogoutIcon = () => <FiLogOut className={iconClass} />;
